import './polyfill';
import { onLocalizationInit } from './ui/localization/i18n';

onLocalizationInit.then(async () => {
  await import('./init');
});
